if (!customElements.get('product-cart-tray')) {
  customElements.define('product-cart-tray', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      this.revision = 0;
      this.syncVisibility();
      this.syncStyle();
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-review-cart]');
        const drawer = document.querySelector('cart-drawer');
        if (link && drawer?.open && this.drawerCurrent !== false) {
          event.preventDefault();
          drawer.open(link);
        }
      }, { signal: this.events.signal });
      document.addEventListener('shopify:section:load', () => this.syncStyle(), { signal: this.events.signal });
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, event => this.refresh(event.cartData));
    }

    syncVisibility() {
      this.hidden = !(Number(this.querySelector('[data-catalog-cart-fragment]')?.dataset.cartCount) > 0);
    }

    syncStyle() {
      const header = document.querySelector('site-header');
      if (!header) return;
      const style = getComputedStyle(header);
      for (const [source, target] of Object.entries({
        '--header-background': '--catalog-cart-background', '--header-text': '--catalog-cart-text',
        '--header-button-background': '--catalog-cart-button-background', '--header-button-text': '--catalog-cart-button-text',
        '--header-radius': '--catalog-cart-radius', '--header-button-radius': '--catalog-cart-button-radius',
      })) {
        const value = style.getPropertyValue(source).trim();
        if (value) this.style.setProperty(target, value);
      }
    }

    async refresh(cart) {
      const revision = ++this.revision;
      try {
        let html = cart?.sections?.['catalog-cart-summary'];
        if (!html) {
          const url = new URL(`${window.Shopify?.routes?.root || '/'}cart`, location.origin);
          url.searchParams.set('section_id', 'catalog-cart-summary');
          const response = await fetch(url, { cache: 'no-store', signal: this.events.signal });
          if (!response.ok) throw new Error('Cart preview unavailable');
          html = await response.text();
        }
        const summary = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-catalog-cart-fragment]');
        if (!summary) throw new Error('Missing cart preview');
        if (revision !== this.revision || !this.isConnected) return;
        this.replaceChildren(summary);
        this.drawerCurrent = true;
        this.syncVisibility();
      } catch (_) {
        if (revision === this.revision) {
          this.hidden = true;
          this.drawerCurrent = false;
        }
      }
    }

    disconnectedCallback() {
      this.events?.abort();
      this.unsubscribe?.();
    }
  });
}
